import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BackendListModel } from "src/app/models/common/list.model";
import { ApiRoutes } from "src/app/services/apiroutes";
import { IReportModel } from "./reports.model";

@Injectable({
    providedIn: 'root'
})

export class ReportsService {
    baseUrl = ApiRoutes.Reports;

    constructor(private http: HttpClient) { }

    getReportList(searchTerm = null, page_size = 10, page = 1, order = '') {
        let url = new URL(this.baseUrl);
        if (searchTerm) {
            url.searchParams.append('search', searchTerm);
        }
        url.searchParams.append('page_size', String(page_size));
        url.searchParams.append('page', String(page));
        if (order != null && order != '') {
            url.searchParams.append('o', String(order));
        }
        return this.http.get<BackendListModel<IReportModel>>(url.toString());
    }

    getReportById(report_id) {
        let url = `${this.baseUrl}${report_id}/`;
        return this.http.get<IReportModel>(url);
    }

    downloadReportById(report_id) {
        let url = `${this.baseUrl}${report_id}/download/`;
        return this.http.get(url, { responseType: 'blob' });
    }

    shareReportById(report_id) {
        let url = `${this.baseUrl}share_report_mail/${report_id}/`;
        return this.http.get(url, { responseType: 'text' });
    }

    postNewReportRequest(data) {
        let url = `${this.baseUrl}new_request/`;
        return this.http.post(url, data);
    }
}
